/**
 * Newsletter scripts
 */

jQuery(function($) {
	// find all the instances of H2 inside the '.entry-content' div
	$('.entry-content h2').each(function() {
		// if it doesn't already have an ID, add an anchor ID to each H2 which is snake-case of the text inside the H2)
		if (!$(this).attr('id')) {
			$(this).attr('id', $(this).text().toLowerCase().replace(/[^a-z0-9]+/g, '-'));
		}

		// add a link to the .newsletter-feature-nav div wih the url #id
		$('.newsletter-feature-nav').append('<a href="#' + $(this).attr('id') + '" class="newsletter-feature-nav-link">' + $(this).text() + '</a>');
	});
});